import api from '@services/api';
import {
  Approver,
  ApproverRequest,
  NewApproverByCluster,
  NewApproverByClusterAndCell,
  NewApproverByProject,
  RemoveByCluster,
  RemoveByClusterAndCell,
} from '../models/approver';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all approver related CRUD calls
 */
export const approversApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    searchApprovers: builder.query<PaginationResponse<Approver>, ApproverRequest>({
      query: (params: ApproverRequest) => ({
        url: encodeURI(
          `/approvers/approver/search?${params.systemId ? `systemId=${params.systemId}` : ''}${
            params.personId ? `&personId=${params.personId}` : ''
          }${params.projectId ? `&projectId=${params.projectId}` : ''}${
            params.clusterCode ? `&clusterCode=${params.clusterCode}` : ''
          }${params.cellCode ? `&cellCode=${params.cellCode}` : ''}&page=${params.page}&size=${params.size}&sortKey=${
            params.sortKey
          }&sortDirection=ASC`,
        ),
      }),
      providesTags: ['Approver'],
    }),
    addApproverByProject: builder.mutation<void, NewApproverByProject>({
      query: (approver) => ({
        url: encodeURI(`/approvers/approver/createByProject`),
        method: 'POST',
        body: approver,
      }),
      invalidatesTags: ['Approver'],
    }),
    addApproverByCluster: builder.mutation<void, NewApproverByCluster>({
      query: (approver) => ({
        url: encodeURI(`/approvers/approver/createByCluster`),
        method: 'POST',
        body: approver,
      }),
      invalidatesTags: ['Approver'],
    }),
    addApproverByClusterAndCell: builder.mutation<void, NewApproverByClusterAndCell>({
      query: (approver) => ({
        url: encodeURI(`/approvers/approver/createByClusterAndCell`),
        method: 'POST',
        body: approver,
      }),
      invalidatesTags: ['Approver'],
    }),
    deleteApprover: builder.mutation<void, number>({
      query: (input: number) => ({
        url: `/approvers/approver/remove?id=${input}`,
        method: 'DELETE',
        body: input,
      }),
      invalidatesTags: ['Approver'],
    }),
    deleteByCluster: builder.mutation<void, RemoveByCluster>({
      query: (input: RemoveByCluster) => ({
        url: `/approvers/approver/removeByCluster`,
        method: 'DELETE',
        body: input,
      }),
      invalidatesTags: ['Approver'],
    }),
    deleteByClusterAndCell: builder.mutation<void, RemoveByClusterAndCell>({
      query: (input: RemoveByClusterAndCell) => ({
        url: `/approvers/approver/removeByClusterAndCell`,
        method: 'DELETE',
        body: input,
      }),
      invalidatesTags: ['Approver'],
    }),
  }),
});

export const {
  useSearchApproversQuery,
  useAddApproverByProjectMutation,
  useAddApproverByClusterMutation,
  useAddApproverByClusterAndCellMutation,
  useDeleteApproverMutation,
  useDeleteByClusterMutation,
  useDeleteByClusterAndCellMutation,
} = approversApi;
